import React, { useState } from "react";
import DataCard from "../../ui/card/DataCard";
import { ExclamationCircleFill } from "react-bootstrap-icons";
import { Col, Container, Row } from "react-bootstrap";
import ViewServiceProviders from "./ViewServiceProviders";

export default function ServicesByProvider({ data, fetchData }) {
  const [selectedServiceData, setSelectedServiceData] = useState(null);

  return (
    <Container fluid style={{ marginTop: 50 }}>
      <Row style={{ marginLeft: 20, marginRight: 20 }}>
        <h2>Services By Provider</h2>
      </Row>
      <Row style={{ margin: 20 }}>
        {data.map((service) => (
          <Col
            md={3}
            style={{ cursor: "pointer", marginBottom: 20 }}
            onClick={() => {
              setSelectedServiceData(service);
              setTimeout(() => {
                window.scrollTo({ top: 10000 });
              }, 500);
            }}
          >
            <DataCard
              icon={<ExclamationCircleFill />}
              title={`${service.name}`}
              color='primary'
              endpoint={`https://ea1-dev.azurewebsites.net/api/userServiceProviderServices/providers/${service.id}`}
              path='/approvals'
              description={`${service.description}`}
            />
          </Col>
        ))}
      </Row>
      {selectedServiceData && (
        <Row>
          <ViewServiceProviders
            service={selectedServiceData}
          ></ViewServiceProviders>
        </Row>
      )}
    </Container>
  );
}
